module.exports = __webpack_public_path__ + "static/media/mappa-open-street-map.262b63a8.png";